"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWaitForElement = void 0;
const react_1 = __importDefault(require("react"));
function useWaitForElement(selector, callback, cleanup, timeout) {
    let ref = react_1.default.useRef(null);
    react_1.default.useEffect(() => {
        const interval = setInterval(() => {
            const element = document.querySelector(selector);
            if (element && ref) {
                ref.current = element;
                clearInterval(interval);
                callback(element);
            }
        }, timeout || 500);
        return cleanup;
    }, [selector, callback, cleanup, timeout]);
    return ref;
}
exports.useWaitForElement = useWaitForElement;
//# sourceMappingURL=useWaitForElement.js.map